import { useState, useEffect } from 'react';
import {
  OnSelectChange,
  Select,
  SelectSize,
  InputText,
  InputSize,
  IconClose,
} from '@ui/src';
import { useAppSelector } from '@store';
import InfoRow from '../info-row';
import { CorporateApplicationStepTwoValuesTypes } from '../types';

import cn from '../new-application.module.css';

const StepTwoValue = ({
  value,
  setValue,
  setValuesList,
  index,
  type,
  values,
  disabled,
  clearErrors,
  applicationScheme,
}: CorporateApplicationStepTwoValuesTypes) => {
  const [nameValue, setNameValue] = useState('');

  const { monthlyTurnoverCorporate: monthlyTurnover, baseCurrency } =
    useAppSelector((state) => state.customersDictionaries);

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement> | OnSelectChange,
  ) => {
    const nextValues = values.map((item, valueIndex) => {
      const result = { ...item };

      if (index === valueIndex) {
        if (e.target.name === `${type}-monthlyTurnoverRangeId-${index}`) {
          result.monthlyTurnoverRangeId = e.target.value as string;
        } else {
          result.name = e.target.value as string;
          setNameValue(e.target.value as string);
        }
      }

      return result;
    });

    setValue(type, nextValues);
    clearErrors([type]);
    setValuesList(nextValues);
  };

  const deleteValue = (id: string) => {
    const nextValues = values.filter((item) => item.id !== id);

    setValue(type, nextValues);

    setValuesList(nextValues);
  };

  useEffect(() => {
    if (value && value.name) {
      setNameValue(value.name);
    }
  }, [value]);

  return (
    <>
      <InfoRow
        title={`${
          type === 'suppliers'
            ? applicationScheme?.suppliersNameTitle || 'Supplier'
            : applicationScheme?.customersNameTitle || 'Customer'
        } ${index + 1}`}
        id={type}
        lessPadding
      >
        <div className={cn.sicCodeRow}>
          <InputText
            name={`${type}-name-${index}`}
            placeholder={`Enter ${
              type === 'suppliers'
                ? applicationScheme?.suppliersNameTitle || 'supplier'
                : applicationScheme?.customersNameTitle || 'customer'
            } name...`}
            value={nameValue}
            onChange={onChange}
            size={InputSize.SMALL}
            className="borderless"
            tabIndex={disabled ? -1 : 0}
            disabled={disabled}
          />
          {!disabled && (
            <button
              type="button"
              className={cn.deleteSicCodeButton}
              onClick={() => deleteValue(value.id)}
              aria-label="Delete button"
              tabIndex={-1}
            >
              <IconClose width={15} height={15} />
            </button>
          )}
        </div>
      </InfoRow>
      <InfoRow
        title={`Expected ${
          type === 'suppliers'
            ? applicationScheme?.suppliersNameTitle || 'Supplier'
            : applicationScheme?.customersNameTitle || 'Customer'
        } ${index + 1} turnover (${baseCurrency?.name})`}
        borderless
        lessPadding
      >
        <Select
          name={`${type}-monthlyTurnoverRangeId-${index}`}
          placeholder="Select range"
          value={value.monthlyTurnoverRangeId}
          onChange={onChange}
          list={monthlyTurnover}
          size={SelectSize.SMALL}
          disabled={disabled}
          selectWrapperClassName={`${disabled ? cn.selectDisabled : ''} ${cn.stepTwoSelectWrapper}`}
          tabIndex={disabled ? -1 : 0}
          borderless
        />
      </InfoRow>
    </>
  );
};

export default StepTwoValue;
